/**
 * The entry point.
 *
 * The theme is applied BEFORE React mounts, and the reason is the same one the
 * inline `<style>` in index.html gives: everything here is client-rendered, so
 * anything left until after the first render is a visible flash. Reading four
 * strings out of localStorage is microseconds; a repaint from the wrong palette
 * is a frame the user sees.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'virtual:hearth-tokens.css'
import './shell.css'
import { Routes } from './router.tsx'
import { applyStoredAppearance } from './appearance.ts'

applyStoredAppearance()

const root = document.getElementById('root')
if (!root) throw new Error('index.html has no #root to mount into')

createRoot(root).render(
  <StrictMode>
    <Routes />
  </StrictMode>,
)
